// no itx for this file

import { ChannelType } from "../../models/ChannelType";
import SignalType from "../../models/SignalType";
import SignalTypes from "../../models/SignalTypes";
import { NameListEntry } from "../NameEntryList";
import { ruleId } from "../ruleId";

export const actorStatus: Array<NameListEntry> = [
  /////////////////////////////////////////
  // ABB
  {
    id: ruleId("Actor-Status-Logic-ABB"),
    signalType: SignalTypes.Switch,
    functionNames: ["logic"],
    dpts: undefined,
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Status-Logic2-ABB"),
    signalType: SignalTypes.Switch,
    texts: ["logic"],
    dpts: undefined,
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Status-BlindPosition-ABB"),
    signalType: SignalTypes.BlindPositionStatus,
    texts: ["height"],
    dpts: ["dpst-5-1", "@ 1 byte"],
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Status-BlindPosition2-ABB"),
    signalType: SignalTypes.BlindPositionStatus,
    functionNames: ["height"],
    dpts: ["dpst-5-1", "@ 1 byte"],
    manufacturers: ["m-0002", "m-0007"], // abb // busch jäger
  },
  {
    id: ruleId("Actor-Status-Ignore1-ABB"),
    signalType: SignalTypes.Ignored,
    functionNames: ["time", "shedding", "forced", "sun", "priorit", "limitation"],
    dpts: undefined,
    manufacturers: ["m-0002"],
  },
  {
    id: ruleId("Actor-Status-Ignore2-ABB"),
    signalType: SignalTypes.Ignored,
    texts: ["time", "shedding", "forced", "sun", "priorit", "limitation"],
    dpts: undefined,
    manufacturers: ["m-0002"],
  },

  //////////////////////////////////////////////////////////////
  // Merten M-000C

  // heating
  {
    id: ruleId("Actor-Status-ValveState-Ignore-Merten"),
    signalType: SignalTypes.Temperature_ControlValueStatus,
    texts: ["response heating"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },

  // jal

  {
    id: ruleId("Actor-Status-Jal-Merten"),
    signalType: SignalTypes.BlindPositionStatus,
    texts: ["height"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },

  {
    id: ruleId("Actor-Status-Slat-Merten"),
    signalType: SignalTypes.SlatPositionStatus,
    texts: ["slat"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Status-Slat-Merten2"),
    signalType: SignalTypes.SlatPositionStatus,
    functionNames: ["slat"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },
  // status dimming
  {
    id: ruleId("Actor-Status-Dimming-Merten"),
    signalType: SignalTypes.DimValueStatus,
    texts: ["brightness value"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Status-Dimming-Merten2"),
    signalType: SignalTypes.DimValueStatus,
    functionNames: ["brightness value"],
    dpts: ["@ 1 byte"],
    manufacturers: ["m-000c", "m-0064"],
  },
  // error
  {
    id: ruleId("Actor-Status-Error-Merten"),
    signalType: SignalTypes.EnvironmentError,
    // ⚠ ONLY-HERE: nicht in Button/Status
    texts: ["alarm"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Status-Error2-Merten"),
    signalType: SignalTypes.EnvironmentError,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["short-circuit"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Status-Error3-Merten"),
    signalType: SignalTypes.Alarm,
    functionNames: ["energy limit"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },

  //   {
  //   id: ruleId("Actor-Status-unknown-Merten"),
  //   signalType: SignalTypes.Unknown,
  //   texts: ["],
  //   dpts: undefined,
  //   manufacturers: ["m-000c","m-0064"],
  // },

  // heating
  {
    id: ruleId("Actor-Status-heating1-Merten"),
    signalType: SignalTypes.Temperature_ValveStateStatus,
    functionNames: ["valve"],
    dpts: ["dpst-1-2"],
    manufacturers: ["m-000c", "m-0064"],
  },
  // {
  //   id: ruleId("Actor-Status-heating2-Merten"),
  //   signalType: SignalTypes.Temperature_TargetStatus_5,
  // ⚠ ONLY-HERE: nicht in Button/Status
  //   functionNames: ["command value"], // 	MEG6003-0006
  //   dpts: ["dpst-1-1"],
  //   manufacturers: ["m-000c","m-0064"],
  // },
  /////////////////////////////////////////////////////////////////////////////
  // Hager M-0009
  {
    id: ruleId("Actor-Status-RGB1-Hager"),
    signalType: SignalTypes.RGBRedSwitchStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    texts: ["ch r"], // Hager TYB673A
    functionNames: ["switch"], // Hager TYB673A
    dpts: ["dpst-1-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Status-RGB2-Hager"),
    signalType: SignalTypes.RGBBlueSwitchStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    texts: ["ch b"], // Hager TYB673A
    functionNames: ["switch"], // Hager TYB673A
    dpts: ["dpst-1-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Status-RGB3-Hager"),
    signalType: SignalTypes.RGBGreenSwitchStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    texts: ["ch g"], // Hager TYB673A
    functionNames: ["switch"], // Hager TYB673A
    dpts: ["dpst-1-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Status-RGB4-Hager"),
    signalType: SignalTypes.RGBRedValueStatus,
    texts: ["ch r"], // Hager TYB673A
    functionNames: ["value"], // Hager TYB673A
    dpts: ["dpst-5-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Status-RGB5-Hager"),
    signalType: SignalTypes.RGBBlueValueStatus,
    texts: ["ch b"], // Hager TYB673A
    functionNames: ["value"], // Hager TYB673A
    dpts: ["dpst-5-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  {
    id: ruleId("Actor-Status-RGB6-Hager"),
    signalType: SignalTypes.RGBGreenValueStatus,
    texts: ["ch g"], // Hager TYB673A
    functionNames: ["value"], // Hager TYB673A
    dpts: ["dpst-5-1"], // Hager TYB673A
    manufacturers: ["m-0009"],
  },
  // status switch
  {
    id: ruleId("Actor-Status-Switch-Merten"),
    signalType: SignalTypes.SwitchStatus,
    texts: ["status obj", "switching"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },
  {
    id: ruleId("Actor-Status-Switch2-Merten"),
    signalType: SignalTypes.SwitchStatus,
    texts: ["response"],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-000c", "m-0064"],
  },

  ///////////////////////////////////////////////////////////////////////////////

  {
    id: ruleId("Actor-Status-Blind1-Weinzierl"),
    signalType: SignalTypes.BlindPositionStatus,
    texts: ["jalousie"],
    functionNames: ["value"], //KNX IP BAOS 777
    dpts: ["dpst-5-1"],
    manufacturers: ["m-00c5"], // Weinzierl
  },

  ////////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////
  // mdt 	M-0083

  {
    id: ruleId("Actor-Status-RGB-MDT"),
    signalType: SignalTypes.RGBValueStatus,
    functionNames: ["status"], //
    texts: ["rgb"], //
    dpts: ["dpst-232-600"], //
    manufacturers: ["m-0083"],
  },

  {
    id: ruleId("Actor-Status-Heating_Zennio1"),
    signalType: SignalTypes.Temperature_Heating_Status,
    functionNames: [/pl status/],
    dpts: ["dpst-1-1"],
    manufacturers: ["m-0071"], // Zennio
  },
  {
    id: ruleId("Actor-Status-Zennio-switch"),
    signalType: SignalTypes.SwitchStatus,
    texts: ["on/off"],
    dpts: ["dpst-1-6"],
    manufacturers: ["m-0071"], // Zennio
  },

  /// ignore
  {
    id: ruleId("Actor-Status-Dummy1"),
    signalType: SignalTypes.Ignored,
    texts: ["dummy"],
    dpts: undefined, // ABB 2CDG 110 079 R0011
  },

  {
    id: ruleId("Actor-Status-Dummy2"),
    signalType: SignalTypes.Ignored,
    functionNames: ["dummy"],
    dpts: undefined, // ABB 2CDG 110 079 R0011
  },
  {
    id: ruleId("Actor-Status-Ignor1"),
    signalType: SignalTypes.Ignored,
    texts: ["operation", "relay"],
    dpts: ["dpst-1-11"],
  },

  // shutter
  {
    id: ruleId("Actor-Status-Shutter1"),
    signalType: SignalTypes.SlatPositionStatus,
    functionNames: ["position of slats", "slat position", "slat 0", "slat angle", "slat - position"], //JAL-01UP.02// // abb 2CDG 110 120 R0011
    dpts: ["dpst-5-1"], //JAL-01UP.02
  },
  {
    id: ruleId("Actor-Status-Shutter2"),
    signalType: SignalTypes.SlatPositionStatus,
    functionNames: ["status slat"],
    dpts: ["@ 1 byte"],
  },
  {
    id: ruleId("Actor-Status-Shutter3"),
    signalType: SignalTypes.SlatPositionStatus,
    texts: ["shutter - slats percentage control"],
    functionNames: [/open.*closed/, /closed.*open/],
    dpts: ["dpst-5-1"],
  },

  /// blind
  {
    id: ruleId("Actor-Status-Blind1"),
    signalType: SignalTypes.BlindPositionStatus,
    functionNames: ["position"], //JAL-01UP.02 JAL-0810M.02
    excludeFunctionNames: ["slat", "lamelle"],
    dpts: ["dpst-5-1"], //JAL-01UP.02  JAL-0810M.02
  },
  {
    id: ruleId("Actor-Status-Blind1"),
    signalType: SignalTypes.BlindPositionStatus,
    texts: ["jalousie - percentage control"],
    functionNames: [/top.*bottom/, /bottom.*top/],
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Actor-Status-Blind2"),
    signalType: SignalTypes.BlindMoveUpStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["up"], //JAL-01UP.02 JAL-0810M.02
    excludeFunctionNames: ["supply", "upper"],
    dpts: ["dpst-1-11"], //JAL-01UP.02 JAL-0810M.02
  },
  {
    id: ruleId("Actor-Status-Blind2_2"),
    signalType: SignalTypes.BlindMoveUpStatus,
    texts: ["shutter - rising relay"],
    functionNames: [/open.*closed/, /closed.*open/],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Status-Blind3"),
    signalType: SignalTypes.BlindMoveDownStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["down"], //JAL-01UP.02
    dpts: ["dpst-1-11"], //JAL-01UP.02
  },
  {
    id: ruleId("Actor-Status-Blind3_2"),
    signalType: SignalTypes.BlindMoveDownStatus,
    texts: ["shutter - lowering relay"],
    functionNames: [/open.*closed/, /closed.*open/],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Status-Blind4"),
    signalType: SignalTypes.BlindMoveStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["move"], //JAL-0810M.02
    dpts: ["dpst-1-11"], //JAL-0810M.02
  },
  {
    id: ruleId("Actor-Status-Blind4_2"),
    signalType: SignalTypes.BlindMoveStatus,
    texts: ["shutter - move status"],
    functionNames: [/stopped.*moving/],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Status-Blind5"),
    signalType: SignalTypes.BlindTopStatus,
    functionNames: ["upper"], //JAL-01UP.02 JAL-0810M.02
    dpts: ["dpst-1-11", "dpst-1-1"], //JAL-01UP.02 JAL-0810M.02 //ABB 2CDG 110 129 R0011
  },
  {
    id: ruleId("Actor-Status-Blind5_2"),
    signalType: SignalTypes.BlindTopStatus,
    texts: ["shutter - totally up"],
    functionNames: [/up/],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Status-Blind6"),
    signalType: SignalTypes.BlindBottomStatus,
    functionNames: ["lower"], ////JAL-01UP.02 JAL-0810M.02
    dpts: ["dpst-1-11", "dpst-1-1"], //JAL-01UP.02 JAL-0810M.02 //ABB 2CDG 110 129 R0011
  },
  {
    id: ruleId("Actor-Status-Blind6_2"),
    signalType: SignalTypes.BlindBottomStatus,
    texts: ["shutter - totally down"],
    functionNames: [/down/],
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Status-Blind7"),
    signalType: SignalTypes.BlindDirectionStatus,
    functionNames: ["direction"], // JAL-01UP.02 JAL-0810M.02
    dpts: ["dpst-1-8"], // JAL-01UP.02 JAL-0810M.02
  },

  {
    id: ruleId("Actor-Status-Blind7_2"),
    signalType: SignalTypes.BlindDirectionStatus,
    texts: ["shutter - move direction status"],
    functionNames: [/up.*down/, /down.*up/],
    dpts: ["dpst-1-8"],
  },

  // GIRA
  // Schaltaktor 16fach / Jalousieaktor 8fach 16A REG
  // 1038 00

  {
    id: ruleId("Actor-Status-Blind8"),
    signalType: SignalTypes.BlindPositionStatus,
    functionNames: ["blind position feedback"],
    objectSize: "1 byte",
  },
  {
    id: ruleId("Actor-Status-Blind9"),
    signalType: SignalTypes.BlindPositionStatus,
    texts: ["status position"],
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Actor-Status-Blind10"),
    signalType: SignalTypes.SlatPositionStatus,
    texts: ["status louvre"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Status-Blind9"),
    signalType: SignalTypes.SlatPositionStatus,
    functionNames: ["slat position feedback", "lamellenposition"],
    objectSize: "1 byte",
  },

  // Environment Wind Alarm
  {
    id: ruleId("Actor-Status-Jalousie-Wind"),
    signalType: SignalTypes.EnvironmentWindAlarm,
    functionNames: ["wind"],
    dpts: ["dpst-1-5", "dpst-1-1"], //JAL-0810.02   // 1-5 == Alarm
  },

  // Environment Rain Alarm
  {
    id: ruleId("Actor-Status-Jalousie-Rain"),
    signalType: SignalTypes.EnvironmentRainAlarm,
    functionNames: ["rain"],
    dpts: ["dpst-1-5", "dpst-1-1"], //JAL-0210.02   // 1-5 == Alarm
  },

  // end GIRA

  //heating
  {
    id: ruleId("Actor-Status-heating1"),
    signalType: SignalTypes.Temperature_TargetStatus,
    functionNames: ["setpoint value", "current setpoint"],
    excludeFunctionNames: ["offset"],
    dpts: ["dpst-9-1", "@ 2 byte"], //
  },
  {
    id: ruleId("Actor-Status-heating1_2"),
    signalType: SignalTypes.Temperature_TargetStatus,
    texts: ["setpoint value", "status current setpoint"], // 	siemens  5WG1605-1DB41 (RTR Teil)
    excludeFunctionNames: ["offset"],
    dpts: ["dpst-9-1"], //
  },
  {
    id: ruleId("Actor-Status-heating1b"),
    signalType: SignalTypes.Temperature_TargetStatus,
    functionNames: ["set temp"],
    texts: ["output"],
    dpts: ["dpst-9-1"], //  jung 2336REGHZRHE
  },
  //
  //   // MWE 19.9.2025
  //   //
  //   // Von Franziska so rein geschrieben,
  //   // kann aber eigentlich nicht sein.
  //   // dpst-6-10 ist ein 8 bit signed value !!!!!
  //   //
  //   // ich tatste es im Moment mal nicht an
  //   //
  //   id: ruleId("Actor-Status-heating1"),
  //   signalType: SignalTypes.Temperature_TargetStatus_5,
  // ⚠ ONLY-HERE: nicht in Button/Status
  //   functionNames: ["current setpoint"],
  //   dpts: ["dpst-6-10"], //
  // },

  {
    id: ruleId("Actor-Status-Heating2"),
    signalType: SignalTypes.Ignored, // mwe 7.1.2026 der status der aktuellen Temperature eines AktorChannels kann nur stören. Wir ignorieren denn
    functionNames: ["temperature value", "actual-temperature"], // mdt AKH-0400.03//
    dpts: ["dpst-9-1"],
  },

  {
    id: ruleId("Actor-Status-Heating2_1"),
    signalType: SignalTypes.Ignored, // siehe Actor-Status-Heating2
    functionNames: ["room temperature - actual"], // GIRA 213900
    manufacturers: ["m-0008"],
    dpts: ["dpst-9-1"],
  },
  {
    id: ruleId("Actor-Status-Heating2_2"),
    signalType: SignalTypes.Temperature_TargetStatus,
    functionNames: ["setpoint temperature"], // GIRA 213900
    manufacturers: ["m-0008"],
    dpts: ["dpst-9-1"],
  },
  // AKH 0600.03
  {
    id: ruleId("Actor-Status-heating3"),
    signalType: SignalTypes.Temperature_ControlValueStatus,
    functionNames: ["control value"],
    dpts: ["dpst-5-1", "@ 1 byte"], // //jung 2178
  },
  {
    channelType: [ChannelType.Heating],
    id: ruleId("Actor-Status-heating3-1"),
    signalType: SignalTypes.Temperature_ControlValueStatus,
    functionNames: ["current"],
    dpts: ["dpst-5-1"], // //
  },
  {
    channelType: [ChannelType.Heating],
    id: ruleId("Actor-Status-heating3-2"),
    signalType: SignalTypes.Temperature_ControlValueStatus,
    functionNames: ["value"],
    texts: ["output"],
    excludeFunctionNames: ["current", "dimming", "brightness"],
    dpts: ["dpst-5-1"], // //??????????????????????????????????????????????????????????????????????
  },

  {
    id: ruleId("Actor-Status-heating4"),
    signalType: SignalTypes.Temperature_ValveStateStatus,
    functionNames: ["valve status"],
    dpts: ["dpst-1-11"],
  },

  // visualisierung des umschaltens vom HVAC Modus-> betriebsartenumschalten
  // {
  //   id: ruleId("Actor-Status-heating6"),
  //   signalType: SignalTypes.OperationMode,
  //   functionNames: ["rhcc"],
  //   dpts: ["dpst-22-101"], //	AKH-0800.02
  // },
  // {
  //   id: ruleId("Actor-Status-heating6"),
  //   signalType: SignalTypes.OperationMode,
  //   functionNames: ["hvac"],
  //   dpts: ["@ 1 byte"], //	AKH-0800.02
  // },

  //RGBW
  {
    id: ruleId("Actor-Status-RGBW1"),
    signalType: SignalTypes.HSV_HueValueStatus,
    functionNames: ["value"], //AKD-0324V.02
    texts: ["hsv hue"], //AKD-0324V.02
    dpts: ["dpst-5-3"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGBW1_1"),
    signalType: SignalTypes.HSV_HueValueStatus,
    texts: [/hsv.*hue/],
    dpts: ["dpst-5-3"],
  },
  {
    id: ruleId("Actor-Status-RGBW1_2"),
    signalType: SignalTypes.HSV_HueValueStatus,
    functionNames: ["status h"], //jung 3904EBLED
    excludeFunctionNames: ["height"],
    dpts: ["dpst-5-3"], //jung 3904EBLED
  },

  {
    id: ruleId("Actor-Status-RGBW1_3"),
    signalType: SignalTypes.HSV_ColorValueStatus,
    functionNames: ["colour hue (h) - status"],
    dpts: ["dpst-5-3"],
  },
  {
    id: ruleId("Actor-Status-RGBW2"),
    signalType: SignalTypes.DimValueStatus, //SignalTypes.HSV_BrightnessValueStatus,
    functionNames: ["value"], //AKD-0324V.02
    texts: ["hsv brightness"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGBW2_2"),
    signalType: SignalTypes.DimValueStatus, // SignalTypes.HSV_BrightnessValueStatus,
    functionNames: ["status v"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },

  {
    id: ruleId("Actor-Status-RGBW2_3"),
    signalType: SignalTypes.DimValueStatus, // SignalTypes.HSV_BrightnessValueStatus,
    functionNames: ["brightness"],
    excludeFunctionNames: ["red", "green", "blue", "white"],
    dpts: ["dpst-232-600"],
  },

  {
    id: ruleId("Actor-Status-RGBW2_4"),
    signalType: SignalTypes.DimValueStatus, // SignalTypes.HSV_BrightnessValueStatus,
    functionNames: ["brightness"],
    excludeFunctionNames: ["red", "green", "blue", "white"],
    dpts: ["dpst-232-600"],
  },
  {
    id: ruleId("Actor-Status-RGBW3"),
    signalType: SignalTypes.HSV_SaturationValueStatus,
    texts: ["hsv saturation"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGBW3_2"),
    signalType: SignalTypes.HSV_SaturationValueStatus,
    functionNames: ["status s"], //jung 3904EBLED
    excludeFunctionNames: ["slat"], // abb 2CDG 110 120 R0011
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Status-RGBW3_3"),
    signalType: SignalTypes.HSV_SaturationValueStatus,
    functionNames: ["saturation (s) - status"],
    dpts: ["dpst-5-1"],
  },
  // RGB
  {
    id: ruleId("Actor-Status-RGB1"),
    signalType: SignalTypes.RGBValueStatus,
    texts: ["rgb"], //AKD-0324V.02
    functionNames: ["3byte", "value"], //AKD-0324V.02 // bes 	DM480XX0
    dpts: ["dpst-232-600"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGB1_2"),
    signalType: SignalTypes.RGBValueStatus,
    functionNames: ["rgb"], //jung 3904EBLED
    dpts: ["@ 3 bytes"], //jung 3904EBLED
  },

  {
    id: ruleId("Actor-Status-RGB1_3"),
    signalType: SignalTypes.RGBValueStatus6Byte,
    dpts: ["dpst-251-600"],
  },
  {
    id: ruleId("Actor-Status-RGB2"),
    signalType: SignalTypes.RGBBlueSwitchStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: [/on.*off/], //AKD-0324V.02
    texts: ["blue"], //AKD-0324V.02
    dpts: ["dpst-1-11", "dpst-1-1"], //AKD-0324V.02 // bes 	DM480XX0
  },
  {
    id: ruleId("Actor-Status-RGB2_2"),
    signalType: SignalTypes.RGBBlueValueStatus,
    functionNames: ["status b", "colour blue (value)"], //jung 3904EBLED
    excludeFunctionNames: ["brightness", "byte"],
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Status-RGB3"),
    signalType: SignalTypes.RGBBlueValueStatus,
    texts: ["blue"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGB4"),
    signalType: SignalTypes.RGBRedSwitchStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: [/on.*off/], //AKD-0324V.02
    texts: ["red"], //AKD-0324V.02
    dpts: ["dpst-1-11", "dpst-1-1"], //AKD-0324V.02// bes 	DM480XX0
  },
  {
    id: ruleId("Actor-Status-RGB4_2"),
    signalType: SignalTypes.RGBRedValueStatus,
    functionNames: ["status r", "colour red (value)"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Status-RGB5"),
    signalType: SignalTypes.RGBRedValueStatus,
    texts: ["red"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGBW4"),
    signalType: SignalTypes.RGBWhiteSwitchStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: [/on.*off/], //AKD-0324V.02
    texts: ["white"], //AKD-0324V.02
    dpts: ["dpst-1-11", "dpst-1-1"], //AKD-0324V.02// bes 	DM480XX0
  },
  {
    id: ruleId("Actor-Status-RGBW4_2"),
    signalType: SignalTypes.RGBWhiteValueStatus,
    functionNames: ["status white"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Status-RGBW5"),
    signalType: SignalTypes.RGBWhiteValueStatus,
    texts: ["white"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGB6"),
    signalType: SignalTypes.RGBGreenSwitchStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: [/on.*off/], //AKD-0324V.02
    texts: ["green"], //AKD-0324V.02
    dpts: ["dpst-1-11", "dpst-1-1"], //AKD-0324V.02 // bes 	DM480XX0
  },
  {
    id: ruleId("Actor-Status-RGB6_2"),
    signalType: SignalTypes.RGBGreenValueStatus,
    functionNames: ["status g", "colour green (value)"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Status-RGB7"),
    signalType: SignalTypes.RGBGreenValueStatus,
    texts: ["green"], //AKD-0324V.02
    dpts: ["dpst-5-1"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-RGB7_2"),
    signalType: SignalTypes.RGBWhiteValueStatus,
    functionNames: ["status w", "colour white (value)"], //jung 3904EBLED
    dpts: ["dpst-5-1"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Status-RGB8"),
    signalType: SignalTypes.RGBValueStatus,
    functionNames: ["rgb"], // //
    excludeFunctionNames: ["absolute", "setting"],
    dpts: ["dpst-232-600"], //
  },

  {
    id: ruleId("Actor-Status-RGB9"),
    signalType: SignalTypes.HSVValueStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["hsv"], // //
    excludeFunctionNames: ["absolute"],
    dpts: ["dpst-232-600", "@ 3 bytes"], //
  },
  // Tuneable white
  {
    id: ruleId("Actor-Status-TuneableWhite1"),
    signalType: SignalTypes.ColorTemperatureKelvinStatus,
    dpts: ["dpst-7-600"], //
  },
  {
    id: ruleId("Actor-Status-TuneableWhite4_3"),
    signalType: SignalTypes.ColorTemperaturePercentStatus,
    texts: ["colour temperature relativ"],
    functionNames: ["status"],
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Actor-Status-TuneableWhite2"),
    signalType: SignalTypes.ColorTemperatureKelvinStatus,
    functionNames: ["rgb", "hsv"], // //
    excludeFunctionNames: ["absolute"],
    dpts: ["dpst-232-600", "@ 3 bytes"], //
  },
  {
    id: ruleId("Actor-Status-TuneableWhite3"),
    signalType: SignalTypes.TunableWhiteTransitionValueStatus,
    functionNames: ["brightness tw"], //Enertex 	1174-DK
    dpts: ["dpst-5-1"], //Enertex 	1174-DK
  },
  {
    id: ruleId("Actor-Status-TuneableWhite"),
    signalType: SignalTypes.TWColdWhiteValueStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["ratio cw in %"], //Enertex 	1174-DK
    dpts: ["dpst-5-1"], //Enertex 	1174-DK
  },

  //// dimm
  {
    id: ruleId("Actor-Status-Dimmer1"),
    signalType: SignalTypes.DimValueStatus,
    functionNames: ["brightness"], //
    dpts: ["dpst-5-1"], //
  },
  {
    id: ruleId("Actor-Status-Diagnostic1"),
    signalType: SignalTypes.Diagnostic,
    functionNames: ["diagnosis"], //JAL-0810M.02
    dpts: ["dpst-16-0", "dpst-16-1"], //JAL-0810M.02 //
  },
  {
    id: ruleId("Actor-Status-Dimmer5"),
    signalType: SignalTypes.Ignored, //Switch-On value (0% = Parameter)
    functionNames: ["switch-on value"], //AKD-0201.02
    dpts: ["dpst-5-1"], //AKD-0201.02
  },

  {
    id: ruleId("Actor-Status-Dimmer4"),
    signalType: SignalTypes.DimValueStatus, //_state of dimming value /DPT_Scaling
    texts: ["rgb"],
    functionNames: ["dim"], //AKD-0203.01 AKD-0324V.02
    dpts: ["dpst-232-600"], //AKD-0203.01 AKD-0324V.02 // //
  },
  {
    id: ruleId("Actor-Status-Dimmer3"),
    signalType: SignalTypes.HSVValueStatus, //_state of dimming value /DPT_Scaling
    // ⚠ ONLY-HERE: nicht in Button/Status
    texts: ["hsv"],
    functionNames: ["dim"], //AKD-0203.01 AKD-0324V.02
    dpts: ["dpst-232-600", "@ 3 bytes"], //AKD-0203.01 AKD-0324V.02 // AKD-0324V.02 LED Controler 3 Ch/RGB
  },
  {
    id: ruleId("Actor-Status-Dimmer3_1"),
    signalType: SignalTypes.HSVValueStatus,
    functionNames: ["brightness (v) - status"],
    dpts: ["dpst-5-1"],
  },

  {
    id: ruleId("Actor-Status-Dimmer3_2"),
    signalType: SignalTypes.HSVValueStatus6Byte, //_state of dimming value /DPT_Scaling
    functionNames: [/hsv.*6 bytes/], //jung 3904EBLED
    dpts: ["@ 6 bytes"], //jung 3904EBLED
  },
  {
    id: ruleId("Actor-Status-Dimmer3.1"),
    signalType: SignalTypes.RGBValueStatus, //_state of dimming value /DPT_Scaling
    texts: ["rgb"],
    functionNames: ["dim"], //AKD-0203.01 AKD-0324V.02
    dpts: ["dpst-232-600"], //AKD-0203.01 AKD-0324V.02 // //
  },
  {
    id: ruleId("Actor-Status-Dimmer2"),
    signalType: SignalTypes.DimValueStatus, //_state of dimming value /DPT_Scaling
    functionNames: ["dim"], //AKD-0203.01 AKD-0324V.02
    dpts: ["dpst-5-1", "dpst-5-3"], //AKD-0203.01 AKD-0324V.02 // //
  },

  /// switch
  {
    id: ruleId("Actor-Status-Switch1"),
    signalType: SignalTypes.SwitchStatusInverted,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["inverted"], //
    dpts: ["dpst-1-11"], //
  },
  {
    id: ruleId("Actor-Status-Switch2"),
    signalType: SignalTypes.SwitchStatus,
    functionNames: undefined,
    excludeFunctionNames: ["block", "lock", "threshold", "sequence"], // // //
    dpts: ["dpst-1-11"], //AKD-0324V.02
  },
  {
    id: ruleId("Actor-Status-Switch3"),
    signalType: SignalTypes.SwitchStatus,
    functionNames: ["status", "switch", /on.*off/, "off/on"], // // //AKD-0203.01  //
    excludeFunctionNames: ["threshold"], //
    dpts: [
      "dpst-1-1",
      "dpst-1-100", //dpst-1-100-> knowing if should be heating or cooling (AKH-0400.03)||| //AKD-0203.01
    ],
  },
  {
    id: ruleId("Actor-Status-Switch4"),
    signalType: SignalTypes.SwitchStatus,
    texts: ["feedback", /switch.*status/], // Merten 647893 , // siemens 	5WG1554-1DB31
    dpts: ["dpst-1-1"],
  },
  {
    id: ruleId("Actor-Status-Dim1"),
    signalType: SignalTypes.DimValueStatus,
    texts: ["status"], // MDT Dali Gateway
    dpts: ["dpst-5-1"],
  },

  // Environment
  {
    id: ruleId("Actor-Status-Environtment1"),
    signalType: SignalTypes.EnvironmentTemperature,
    texts: ["outside temperature"],
    dpts: ["dpst-9-1"], //mdt 	AKH-0400.03
  },

  // Lock
  {
    id: ruleId("Actor-Status-LockStatus"),
    signalType: SignalTypes.LockStatus,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["lock", "block"], //
    dpts: [
      "dpst-1-11", // 1-11 == state
    ],
  },

  // Error
  {
    id: ruleId("Actor-Status-Error"),
    signalType: SignalTypes.EnvironmentError,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: [
      "exceeded", //
      "below", //
      "alarm", //AKD-0203.01 JAL-0810M.02 JAL-0810M.02
      "failure", //
      "warning", //
      "error", //AKD-0203.01
      "service required", //
      "overcur",
      "short circuit",
    ],
    dpts: ["dpst-1-1", "dpst-1-5"], //AKD-0203.01 //JAL-0810M.02
  },

  // Time
  {
    id: ruleId("Actor-Status-Time1_hrs"),
    signalType: SignalTypes.Time,
    functionNames: ["hours", "time"], // //
    excludeFunctionNames: ["operating "],
    dpts: ["dpst-7-7"], //
  },
  {
    id: ruleId("Actor-Status-Time1_sec"),
    signalType: SignalTypes.Time,
    functionNames: ["hours", "time"], // //
    excludeFunctionNames: ["operating "],
    dpts: ["dpst-13-100"], //
  },
  {
    id: ruleId("Actor-Status-Time2"),
    signalType: SignalTypes.Date,
    functionNames: ["date"], // //
    dpts: ["dpst-11-1"], //
  },
  {
    id: ruleId("Actor-Status-Time3"),
    signalType: SignalTypes.DateTime,
    functionNames: ["date / time"], // //
    dpts: ["dpst-19-1"], //
  },
  {
    id: ruleId("Actor-Status-Time3_2"),
    signalType: SignalTypes.DateTime,
    texts: ["date / time"], // //
    dpts: ["dpst-19-1"], //
  },
  {
    id: ruleId("Actor-Status-DayNight1"),
    signalType: SignalTypes.DayNight,
    functionNames: ["day"], // //
    dpts: ["dpst-1-24"], //
  },
  //// Environment
  //

  {
    id: ruleId("Actor-Status-opmode"),
    signalType: SignalTypes.OperationMode_Status,
    functionNames: ["status", "currently"],
    dpts: ["dpst-20-102"],
  },
  {
    id: ruleId("Actor-Status-opmode_2"),
    signalType: SignalTypes.OperationMode_Status,
    texts: ["special mode"],
    dpts: ["dpst-20-102"],
  },

  {
    id: ruleId("Actor-Status-Heating8"),
    signalType: SignalTypes.Temperature_TargetShift_9_Status,
    functionNames: ["shift"], // //
    dpts: ["dpst-9-2", "@ 2 bytes", "dpst-9-1"], //jung 2178
  },
  {
    id: ruleId("Actor-Status-Heating8a"),
    signalType: SignalTypes.Temperature_TargetShift_6_Status,
    functionNames: ["shift"], // //
    dpts: ["dpst-6-10"],
  },
];

export const actorStatusSensitiv: Array<NameListEntry> = [
  // Dimmer

  // ABB SD/S4.16.1 Switch/Dim Actor, 4-fold, MDRC
  // !!! THIS IS NOT THE DIMVALUESTATUS FOR THE ABB DEVICE, ITS A VERY SPECIFIC COMOBJECT THAT ONLY HAS 7 POSSIBLE VALUES
  // {
  //   id: ruleId("Actor-Status-sensitiv-1"),
  //   signalType: SignalTypes.DimValueStatus,
  //   objectSize: "1 byte",
  //   functionNames: ["status byte"],
  //   channelType: ChannelType.Dimmer,
  // },
  {
    id: ruleId("Actor-Status-sensitiv-1"),
    signalType: SignalTypes.Temperature_ControlValueStatus,
    dpts: ["dpst-5-1"],
    functionNames: ["control value"],
    channelType: [ChannelType.Heating],
  },

  {
    id: ruleId("Actor-Status-sensitiv-1_2"),
    signalType: SignalTypes.Temperature_ValveStateStatus,
    dpts: ["dpst-1-1"],
    functionNames: ["control value"],
    channelType: [ChannelType.Heating],
  },
  {
    id: ruleId("Actor-Status-sensitiv-2"),
    signalType: SignalTypes.Temperature_ControlValueStatus,
    oldSignalType: SignalTypes.Unknown,
    objectSize: "1 byte",
    functionNames: ["status byte"],
    channelType: [ChannelType.Heating],
  },
  {
    id: ruleId("Actor-Status-sensitiv-2a"),
    signalType: SignalTypes.Temperature_ControlValueStatus,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-5-1"],
    texts: ["status control value"],
    channelType: [ChannelType.Heating],
  },
  {
    id: ruleId("Actor-Status-sensitiv-2c"),
    signalType: SignalTypes.Temperature_ValveStateStatus,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-1-1"],
    texts: ["status control value"],
    channelType: [ChannelType.Heating],
  },

  {
    id: ruleId("Actor-Status-sensitiv-heating5"),
    signalType: SignalTypes.Temperature_Heating_Status,
    // ⚠ ONLY-HERE: nicht in Button/Status
    functionNames: ["control value >", "heating indication", "heating - status"],
    dpts: ["dpst-1-11", "dpst-1-1"], //	-
    channelType: [ChannelType.Heating],
  },
  {
    id: ruleId("Actor-Status-sensitiv-3"),
    signalType: SignalTypes.SwitchStatus,
    oldSignalType: SignalTypes.Unknown,
    objectSize: "1 bit",
    functionNames: ["status bit"],
    channelType: [ChannelType.Switch],
  },
  {
    id: ruleId("Actor-Status-sensitiv-4"),
    signalType: SignalTypes.DimValueStatus,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-5-1"],
    functionNames: ["feedback"],
    channelType: [ChannelType.Dimmer],
  },
  {
    id: ruleId("Actor-Status-sensitiv-5"),
    signalType: SignalTypes.SlatPositionStatus,
    oldSignalType: SignalTypes.Unknown,
    dpts: ["dpst-5-1"],
    functionNames: ["status slat"],
    excludeFunctionNames: ["height"],
    channelType: [ChannelType.Jalousie],
  },
  {
    id: ruleId("Actor-Status-sensitiv-switch-5"),
    signalType: SignalTypes.SwitchStatus,
    oldSignalType: SignalTypes.Unknown,
    functionNames: ["feedback"],
    dpts: ["dpst-1-1"],
    channelType: [ChannelType.Switch],
  },
  {
    id: ruleId("Actor-Status-sensitiv-Dimming1"),
    channelType: [ChannelType.Dimmer],
    oldSignalType: SignalTypes.Unknown,
    signalType: SignalTypes.DimValueStatus,
    functionNames: ["value status"],
    dpts: ["dpst-5-1"],
  },
  {
    id: ruleId("Actor-Status-sensitive-Switch5"),
    channelType: [ChannelType.Switch],
    oldSignalType: SignalTypes.Unknown,
    signalType: SignalTypes.SwitchStatus,
    texts: ["status"],
    dpts: ["dpst-1-1"],
  },
];
